import { Injectable } from '@angular/core';

@Injectable()
export class StateService {
    public state: any;
    public constructor() { }
}